import { render, staticRenderFns } from "./SitiosInteres.vue?vue&type=template&id=07e3581e&scoped=true"
import script from "./SitiosInteres.vue?vue&type=script&lang=js"
export * from "./SitiosInteres.vue?vue&type=script&lang=js"
import style0 from "./SitiosInteres.vue?vue&type=style&index=0&id=07e3581e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e3581e",
  null
  
)

export default component.exports